import "font-awesome/css/font-awesome.min.css";
import "semantic-ui-css/semantic.min.css";
import LoginForm from "./component/LoginForm";
import "./style/index.css";


export default function LoginPage() {


  return (
    <>
      <LoginForm />
    </>
  );
}

